import React, { useEffect, useState } from "react";
import { getResources } from "../../utils/apiUtils.js";
import MedHelpList from "../../components/MedHelpList/MedHelpList.js";
import "./MedHelpPage.scss";

function MedHelpPage() {
  const [allResources, setAllResources] = useState([]);

  const fetchResources = async () => {
    try {
      const { data } = await getResources();
      setAllResources(data);
    } catch (error) {
      console.error("Error fetching resources:", error);
    }
  };
  console.log(allResources);
  useEffect(() => {
    fetchResources();
  }, []);

  return (
    <div>
      <MedHelpList
        allResources={allResources}
        setAllResources={setAllResources}
      />
    </div>
  );
}

export default MedHelpPage;
